import React from "react";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";

import {getSRRICategory} from "../../../FinalStep/FinalStep";
import useStyles from "../../../FinalStep/components/RiskProfileCategoryCard/styles"

const RiskProfileCardForProductSelection = ({sri}) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.riskProfileCard}>
      <Grid item xs={12}>
        <Grid container spacing={1} alignItems={"center"}>
          <Grid item xs={'auto'} className={clsx(classes.riskProfileCardTitle, 'product-selection')}>
            Risikoprofil:
          </Grid>
          <Grid item xs>{getSRRICategory(sri)}</Grid>
        </Grid>
        <Grid container spacing={1} alignItems={"center"}>
          <Grid item xs={'auto'} className={clsx(classes.riskProfileCardTitle, 'product-selection')}>
            Risikoklasse:
          </Grid>
          <Grid item xs>{sri}</Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default RiskProfileCardForProductSelection;